import React from "react";
import { PhoneIcon } from "lucide-react";
import { firm, footerGroups, resultsDisclaimer, RESULTS_PATH } from "../data/site";
import { SiteLink } from "./SiteLink";
export function SiteFooter() {
  return <footer className="on-dark bg-ink text-white" data-id="element-370" data-mp="3mgrfwug6vb07">
      <div className="page-container py-14 md:py-16" data-id="element-371" data-mp="3mf6gorixj3w0">
        <div className="grid gap-10 md:grid-cols-12" data-id="element-372" data-mp="3hhenlu6jtbq8">
          <div className="md:col-span-6" data-id="element-373" data-mp="3dguvx64qv0bh">
            <p className="text-h3 font-bold" data-id="element-374" data-mp="3dhw9bh98fywd">{firm.displayName}</p>
            <p className="mt-1 text-white/80" data-id="element-375" data-mp="38i1ej2mc6p61">
              Michigan motorcycle injury representation.
            </p>
            <a href={firm.phoneHref} className="mt-5 inline-flex min-h-[48px] items-center gap-3 text-h3 font-extrabold text-white hover:underline" data-id="element-376" data-mp="33hvlpj4bywmd">
              <PhoneIcon aria-hidden="true" className="h-6 w-6" data-id="element-377" data-mp="11rtrzey50yrg" />
              {firm.phoneDisplay}
            </a>
            <div className="mt-3" data-id="element-378" data-mp="wta9xpmo074d">
              <SiteLink path="/contact-us/" className="inline-flex min-h-[44px] items-center text-label font-semibold text-white underline underline-offset-4" data-id="element-379" data-mp="wq4hc0etun3w">
                Contact the firm
              </SiteLink>
            </div>
          </div>
          {footerGroups.map(group => <nav key={group.id} aria-labelledby={group.id} className="md:col-span-3" data-id="element-380" data-mp="vuifo5diqbm1">
              <h2 id={group.id} className="text-label font-bold text-white/80" data-id="element-381" data-mp="10sai3tbshg4h">
                {group.label}
              </h2>
              <ul className="mt-3" data-id="element-382" data-mp="1ojpfd7opl78v">
                <li data-id="element-383" data-mp="1tgpjhd1zzzxc"><SiteLink path={RESULTS_PATH} className="inline-flex min-h-[48px] items-center text-label font-bold text-white underline underline-offset-4" data-id="element-384" data-mp="1tgpl1hhnc7zg">Results</SiteLink></li>
                {group.links.map(link => <li key={link.path} data-id="element-385" data-mp="1jp20m0jibr7h">
                    <SiteLink path={link.path} className="inline-flex min-h-[44px] items-center text-label font-semibold text-white underline-offset-4 hover:underline" data-id="element-386" data-mp="27g7g2eljchh9">
                      {link.label}
                    </SiteLink>
                  </li>)}
              </ul>
            </nav>)}
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-white/20 pt-6 text-meta text-white/80 md:flex-row md:justify-between" data-id="element-387" data-mp="2d27w367mk23d">
          <p data-id="element-388" data-mp="2823gdiejjbe7">{resultsDisclaimer}</p>
          <div data-id="element-389" data-mp="285952wj9cb9e">
            <SiteLink path="/privacy-policy/" className="inline-flex min-h-[44px] items-center font-semibold text-white underline underline-offset-4" data-id="element-390" data-mp="2341w4u5dp615">Privacy Policy</SiteLink>
            <p data-id="element-391" data-mp="1yc0oxmn2i5hz">© 2026 {firm.legalName}</p>
          </div>
        </div>
      </div>
    </footer>;
}